export type EditMenuDefaultActions =
  | "define"
  | "translate"
  | "promptForReplace"
  | "cut"
  | "copy"
  | "paste"
  | "delete"
  | "select"
  | "selectAll"
  | "transliterateChinese"
  | "insertDrawing"
  | "captureTextFromCamera"
  | "toggleBoldface"
  | "toggleItalics"
  | "toggleUnderline"
  | "makeTextWritingDirectionRightToLeft"
  | "makeTextWritingDirectionLeftToRight"
  | "showTextFormattingOptions"
  | "findSelected"
  | "addShortcut"
  | "accessibilitySpeak"
  | "accessibilitySpeakLanguageSelection"
  | "accessibilityPauseSpeaking"
  | "share";